"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var classnames_1 = __importDefault(require("classnames"));

var react_1 = require("react");

var react_router_dom_1 = require("react-router-dom");

var prop_types_1 = require("prop-types");

var RelatedAnalysesModal_1 = __importDefault(require("./RelatedAnalysesModal"));

require("./index.css");

var index_1 = require("../../index");

var LinkedNavigationItem = function (_a) {
  var title = _a.title,
      _b = _a.items,
      items = _b === void 0 ? [] : _b,
      _c = _a.analysesTitle,
      analysesTitle = _c === void 0 ? '' : _c,
      isRelatedAnalyses = _a.isRelatedAnalyses,
      isKfa = _a.isKfa,
      hypothesisIndex = _a.hypothesisIndex,
      projectId = _a.projectId,
      getViewPathForAnalysis = _a.getViewPathForAnalysis;

  var _d = (0, react_1.useState)(false),
      isModalOpen = _d[0],
      setIsModalOpen = _d[1];

  var handleCloseModal = function () {
    setIsModalOpen(false);
  };

  if (isRelatedAnalyses) {
    return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
      children: [(0, jsx_runtime_1.jsx)("div", __assign({
        "data-backdrop": "static"
      }, {
        children: (0, jsx_runtime_1.jsx)(RelatedAnalysesModal_1.default, {
          show: isModalOpen,
          onClose: handleCloseModal,
          relatedAnalyses: items,
          projectId: projectId,
          setCloseModal: handleCloseModal,
          getViewPathForAnalysis: getViewPathForAnalysis
        }, void 0)
      }), void 0), (0, jsx_runtime_1.jsx)("div", __assign({
        className: "related-analyses-title",
        "data-testid": "related-analyses-title"
      }, {
        children: title
      }), void 0), (0, jsx_runtime_1.jsxs)("div", __assign({
        className: (0, classnames_1.default)('related-analyses-container')
      }, {
        children: [(0, jsx_runtime_1.jsxs)("div", __assign({
          className: "related-analyses-item"
        }, {
          children: [analysesTitle, " (", items.length, " related analyses)"]
        }), void 0), (0, jsx_runtime_1.jsx)("div", {
          children: (0, jsx_runtime_1.jsx)("button", __assign({
            type: "button",
            "data-testid": "related-analyses",
            className: (0, classnames_1.default)('icon-button'),
            onClick: function () {
              return setIsModalOpen(true);
            }
          }, {
            children: (0, jsx_runtime_1.jsx)(index_1.Icon, {
              name: "hyperlink",
              width: 16,
              className: "fill icon-orange-theme"
            }, void 0)
          }), void 0)
        }, void 0)]
      }), void 0)]
    }, void 0);
  }

  return items.length > 0 && (0, jsx_runtime_1.jsxs)("div", {
    children: [(0, jsx_runtime_1.jsx)("span", __assign({
      "data-testid": "connected-analyses-header",
      className: (0, classnames_1.default)('connected-analyses__header')
    }, {
      children: title
    }), void 0), items.map(function (analysis, index) {
      return (0, jsx_runtime_1.jsx)("div", __assign({
        className: "navigation-connected-content"
      }, {
        children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({
          to: getViewPathForAnalysis(projectId, analysis),
          "data-testid": "navigation-connected-content-" + hypothesisIndex + "-" + index,
          className: "" + (index === 0 && !isKfa && title !== "Key Focus Area" ? "connected-analyses__list__link__first" : "connected-analyses__list__link")
        }, {
          children: analysis.title
        }), analysis.contentId)
      }), void 0);
    })]
  }, void 0);
};

LinkedNavigationItem.propTypes = {
  title: prop_types_1.string.isRequired,
  analysesTitle: prop_types_1.string.isRequired,
  items: (0, prop_types_1.arrayOf)((0, prop_types_1.oneOfType)([prop_types_1.string, (0, prop_types_1.shape)({
    contentThreadId: prop_types_1.string,
    contentId: prop_types_1.string,
    title: prop_types_1.string,
    links: (0, prop_types_1.arrayOf)(prop_types_1.string)
  })])).isRequired,
  hypothesisIndex: prop_types_1.number,
  projectId: prop_types_1.number.isRequired,
  isKfa: prop_types_1.bool,
  isRelatedAnalyses: prop_types_1.bool,
  getViewPathForAnalysis: prop_types_1.func.isRequired
};
LinkedNavigationItem.defaultProps = {
  hypothesisIndex: 0,
  isRelatedAnalyses: false,
  isKfa: false
};
exports.default = LinkedNavigationItem;